import { render, staticRenderFns } from "./vipread.vue?vue&type=template&id=26020e44&scoped=true"
import script from "./vipread.vue?vue&type=script&lang=js"
export * from "./vipread.vue?vue&type=script&lang=js"
import style0 from "./vipread.vue?vue&type=style&index=0&id=26020e44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26020e44",
  null
  
)

export default component.exports